import React from 'react'
import Popup from '@src/shared-components/Popup'
import Button from '@src/shared-components/Button'
import useT from '@src/hooks/useT/useT'
import classes from './MainPopup.style'
import ChangeLanguageMenu from './ChangeLanguageMenu'

type Props = {
    isOpen: boolean
    onClose?: () => void
    onInstallClick: () => void
    onSupportClick: () => void
}

function MainPopup({
    isOpen, onClose, onInstallClick, onSupportClick,
}: Props): JSX.Element {
    const {
        t,
    } = useT()

    return (
        <Popup
            css={classes.popup}
            isOpen={isOpen}
            onClose={onClose}
        >
            <div css={classes.root}>
                <div css={classes.content}>
                    <div css={classes.hr} />
                    <Button
                        variant="quaternary"
                        onClick={onInstallClick}
                    >
                        {t('INSTALL_GATEWAY')}
                    </Button>
                    <div css={classes.hr} />
                    <ChangeLanguageMenu onClose={onClose} />
                    <div css={classes.hr} />
                    <Button
                        variant="quaternary"
                        onClick={onSupportClick}
                    >
                        {t('SUPPORT')}
                    </Button>
                    <div css={classes.hr} />
                </div>
            </div>
        </Popup>
    )
}

export default MainPopup
